import { connect } from 'react-redux';

import Phi from '../../Phi/Phi'
import Actions from '../../Actions/Creators';
import NavDrawer from './Component/NavDrawer';

const mapStateToProps = (state, ownProps) => ({
    user: state.auth.userProfile,
    childList: [],
    selectedChild: 0,
    emailId: Phi.User.profile().username,
    orgName: state.organization.currentProgram.organization_name
});

const mapDispatchToProps = (dispatch) => ({
      logoutUser: () => dispatch(Actions.logoutUser()) // Action to logout
})

export default connect(mapStateToProps, mapDispatchToProps)(NavDrawer)